import { Box, Typography, Button, Modal, Tooltip } from '@mui/material';
import * as React from 'react';
import { FlexBoxInline, PageHeaderSx, PrimaryBtnSx, SecondaryBtnSx, TooltipSlotProps } from '../@shared/templates';
import { Palette, Sizes } from '../@shared/palette';
import { AlertComponent } from './AlertComponent';
import { NotificationModel } from '../reducers/main/mainModel';
import { ButtonComponent } from './ButtonComponent';
import { ContextHelper } from './ContextHelper';

const style = {
  position: 'absolute' as 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 800,
  bgcolor: Palette.backgroundColorCard,
  border: '2px solid #000',
  boxShadow: 24,
  p: 4,
  maxHeight: "90vh"
};

export type ModalBaseType = {
  children?: React.ReactNode,
  onSave?: () => void,
  onCancel: () => void,
  isDisabledSave?: boolean,
  primaryBtnText?: string,
  secondBtnText?: string,
  title: string,
  isOpen: boolean,
  width?: number,
  notification?: NotificationModel,
  handleCloseNotification?: () => void,
  isProcessing?: boolean,
  contextHelperContent?: React.JSX.Element,
  description?: string,
  saveBtnTooltip?: React.JSX.Element,
}

export const ModalBase = (props: ModalBaseType) => {
  return <Modal
    open={props.isOpen}
    onClose={props.onCancel}
    aria-labelledby="modal-modal-title"
    aria-describedby="modal-modal-description"
    sx={{
      "& .MuiBox-root": {
        border: "none"
      }
    }}
  >
    <Box sx={{ ...style, width: props.width ?? style.width }}>
      {props.notification && <Box sx={{ marginBottom: "10px" }}>
        <AlertComponent notification={props.notification} onClose={props.handleCloseNotification} isClosable />
      </Box>
      }
      <ContextHelper content={props.contextHelperContent}>
        <Typography id="modal-modal-title" sx={{ ...PageHeaderSx, fontSize: Sizes.pageSecondTitle }}>
          {props.title}
        </Typography>
      </ContextHelper>
      {props.description && <Typography id="modal-modal-title" sx={{ marginTop: "10px", fontSize: Sizes.textPrimary, color: Palette.textColorPrimary }}>
        {props.description}
      </Typography>}
      <Box sx={{ overflowY: "auto", maxHeight: `calc(80vh - ${props.notification ? 180 : 120}px)`, marginBottom: "20px", marginTop: "10px" }}>
        {props.children}
      </Box>
      <Box sx={{ ...FlexBoxInline, justifyContent: "flex-end" }}>
        <Button disabled={props.isProcessing} sx={{ ...SecondaryBtnSx, border: "none" }} onClick={props.onCancel}>{props.secondBtnText ? props.secondBtnText : "Cancel"}</Button>
        {props.onSave && <Tooltip placement="right-start" slotProps={TooltipSlotProps} open={!!props.saveBtnTooltip} title={props.saveBtnTooltip ?? ""} arrow>
          <ButtonComponent text={props.primaryBtnText ? props.primaryBtnText : "Save"} disabled={props.isDisabledSave} isProcessing={props.isProcessing} onClick={props.onSave} sx={PrimaryBtnSx} />
        </Tooltip>}
      </Box>
    </Box>
  </Modal>
}
